import React from 'react'
import { ProfileWrapper } from './style'
import { Link, useLocation } from 'react-router-dom'

const SettingOptions = [
  {
    id: '1',
    Desc: 'Profile',
    path: '/profile-setting',
    brief: 'Your Profile details',
  },
  {
    id: '2',
    Desc: 'Next of kin',
    path: '/next-of-kin-setting',
    brief: 'Next of Kin details',
  },
  {
    id: '3',
    Desc: 'Change Pin',
    path: '/change-pin',
    brief: 'Change Your app Pin',
  },
  {
    id: '4',
    Desc: 'Password Settings',
    path: '/password-setting',
    brief: 'Change Your password to keep Your account safe',
  },
]
const Profiles = () => {
  let location = useLocation()
  return (
    <ProfileWrapper>
      <h1>Profile</h1>
      <div className="cards">
        {SettingOptions.map((item) => (
          <Link to={item.path} state={{ backgroundLocation: location }}>
            <div className="box" key={item.id}>
              <p>{item.Desc}</p>
              <span>{item.brief}</span>
            </div>
          </Link>
        ))}
      </div>
    </ProfileWrapper>
  )
}
export { Profiles }
